<ng-container *transloco="let t">
	@if ($order(); as order) {
		@if (order.isTestOrder) {
			<div class="w-full bg-zeiss-gray-11 flex justify-center font-semibold text-white uppercase">
				{{ t('productSummary.texts.testOrder') }}
			</div>
		}
		@if (order.orderType === 'ECPReplacement') {
			<div class="w-full bg-zeiss-gray-11 flex justify-center font-semibold text-white">
				{{ t('productSummary.texts.replacementOrder') + ' ' + order.originalOrder }}
			</div>
		}
		@if ($settings(); as settings) {
			<div class="px-m flex flex-col gap-m pb-m">
				<!-- Product name -->
				<div class="flex items-center">
					<div>
						<h4 class="print:mb-0 print:pt-0">
							<label class="text-headline uppercase text-eyebrow-l">
								{{ t('productSummary.headlines.title') }}
							</label>
						</h4>
						<h3 class="flex text-headline text-hl-xxl flex-grow justify-start">
							ZEISS Optical Inserts
						</h3>
					</div>
					<div
						class="flex w-[96px] min-w-[96px] xl:min-w-[224px] h-[96px] print:hidden xl:h-[224px] bg-thumbnail bg-contain justify-end rounded-xl"
					></div>
				</div>
				<!-- Reference -->
				<section class="flex flex-row">
					<i class="flex flex-col justify-start mr-s">
						<vis-ods-icon-component name="type" height="24px" width="24px" class="fill-body" />
					</i>
					<div class="flex flex-col">
						<h4 class="text-label text-body">
							{{ t('productSummary.texts.productType') }}
						</h4>
						<span class="text-input text-headline">
							{{ $product()?.productType?.displayName }}
						</span>
					</div>
				</section>
				<!-- Reference -->
				@if (settings.show_order_reference) {
					<section class="flex flex-row">
						<i class="flex flex-col justify-start mr-s">
							<vis-ods-icon-component
								name="flowsheet"
								height="24px"
								width="24px"
								class="fill-body"
							/>
						</i>
						<div class="flex flex-col">
							<h4 class="text-label text-body">
								{{ t('productSummary.texts.reference') }}
							</h4>
							<span class="text-input text-headline">
								{{ order.reference?.text }}
							</span>
						</div>
					</section>
				}
				@if ($isReader()) {
					<!-- Reader Dioptren values -->

					<section class="flex flex-row">
						<i class="flex flex-col justify-start mr-s">
							<vis-ods-icon-component name="receipt" height="24px" width="24px" class="fill-body" />
						</i>
						<div class="flex flex-col">
							<h4 class="text-label text-body">
								{{ t('order.subcomponents.readers.info') }}
							</h4>
							<span class="text-input text-headline">
								{{ t('order.subcomponents.readers.produtctLabels.' + $product()?.id) }}
							</span>
						</div>
					</section>
				} @else {
					<!-- VRX/RX -->
					<div class="flex flex-col bg-light-02 p-s rounded-[8px]">
						<app-rx-vrx-display
							*ngIf="!$vrxValuesLoading(); appLoadingAnimation"
							[showVrxData]="settings.show_modified_prescription && $vrx() !== null"
							[rx]="$rx()"
							[$vrxData]="$vrxValues"
						/>
						@if ($displayVrx()) {
							<div class="flex">
								<span class="text-body text-body-s"
									>{{ t(vrxReasonKey()) + ' ' }}
									<button
										class="text-interaction-link text-body-s"
										(click)="openVRXInformationPopup()"
									>
										{{ t('productSummary.buttons.vrxInformation') }}
									</button>
								</span>
							</div>
						}
					</div>
				}

				<!-- Engraving -->
				@if (settings.engraving && $product()?.id === 1) {
					<section class="flex flex-row">
						<i class="flex flex-col justify-start mr-s">
							<vis-ods-icon-component
								name="engraving"
								height="24px"
								width="24px"
								class="fill-body"
							/>
						</i>
						<div class="flex flex-col">
							<h4 class="text-label text-body">
								{{ t('productSummary.headlines.engraving') }}
							</h4>
							<span class="text-input text-headline">{{
								order.personalization?.text
									? order.personalization?.text
									: t('productSummary.texts.noEngravingAdded')
							}}</span>
						</div>
					</section>
				}

				<!-- Color -->
				@if (
					settings.color_dot &&
					$product()?.id === 1 &&
					order.color?.colorCode &&
					$colors().length > 1
				) {
					<div class="flex flex-row pb-m pt-m">
						<div class="flex flex-col mr-s">
							<span
								[style.backgroundColor]="order.color?.colorCode"
								class="w-[24px] h-[24px] rounded-full"
							>
							</span>
						</div>
						<div class="flex flex-col">
							<div class="text-label text-body">{{ t('productSummary.headlines.color') }}</div>

							<span class="text text-input">
								{{ order.color?.colorCode }}
							</span>
						</div>
					</div>
				}
				<!-- Shipping address -->
				<section class="flex flex-row">
					<i class="flex flex-col mr-s">
						<vis-ods-icon-component
							name="packageVariantClosed"
							height="24px"
							width="24px"
							class="fill-body"
						></vis-ods-icon-component>
					</i>
					<div class="flex flex-col">
						<div class="text-label text-body">
							{{ t('orderSummary.headlines.shipToStore') }}
						</div>
						@if ($shipToStoresLoading()) {
							<beyond-online-loading-spinner size="2xs"></beyond-online-loading-spinner>
						} @else {
							<div class="flex flex-col text-body-s">
								@if (order.shipTo) {
									@if (order.shipTo.customerNumber) {
										<span class="text-input">
											{{ order.shipTo.firstLineName + ' (' + order.shipTo.customerNumber + ')' }}
											{{ order.shipTo.secondLineName }}
										</span>
										<span class="text-body">{{
											order.shipTo.street + ', ' + order.shipTo.city
										}}</span>
									} @else {
										<span class="text-input">
											{{ order.shipTo.firstLineName }}
											{{ order.shipTo.secondLineName }}
										</span>
										<span class="text-body text-body-s">
											{{ order.shipTo.street }}
											{{ order.shipTo.houseNumber }},
											{{ order.shipTo.zipCode }}
											{{ order.shipTo.city }},
											{{ order.shipTo.countryCode }}
										</span>
										<span class="flex" beyond-online-text>
											@if (order.shipTo.email) {
												<vis-ods-icon-component
													class="pr-xs"
													name="mail"
													width="14"
													height="14"
												></vis-ods-icon-component>
											}
											{{ order.shipTo.email }}</span
										>
										<span class="flex" beyond-online-text>
											@if (order.shipTo.phone) {
												<vis-ods-icon-component
													class="pr-xs"
													name="telephone"
													width="14"
													height="14"
												></vis-ods-icon-component>
											}
											{{ order.shipTo.phonePrefix?.phonePrefix }} {{ order.shipTo.phone }}</span
										>
									}
								} @else {
									{{ t('productSummary.texts.noStoreSelected') }}
								}
								<div class="flex">
									@if ($editShippingAddressEnabled()) {
										<button
											id="editShippingAddressButton"
											beyond-online-link
											class="print:hidden text-interaction-link text-left ml-xs"
											(click)="editShippingAddress()"
										>
											{{ t('orderSummary.buttons.changeShipToStore') }}
										</button>
									}
								</div>
							</div>
						}
					</div>
				</section>
				<hr beyond-online-divider />
				<!-- Ordered from address -->
				<div class="flex flex-row">
					<i class="flex flex-col mr-s">
						<vis-ods-icon-component
							name="store"
							height="24px"
							width="24px"
							class="fill-body"
						></vis-ods-icon-component>
					</i>
					<div class="flex flex-col">
						<span class="text-label text-body">
							{{ t('orderSummary.headlines.soldToStore') }}
						</span>
						<div class="flex flex-col text-body-s">
							<div class="flex space-x-2xs">
								<span class="text-input text-headline">{{
									$selectedSoldToStore()?.firstLineName +
										' (' +
										$selectedSoldToStore()?.customerNumber +
										')'
								}}</span>
								<span class="text-input text-headline">{{
									$selectedSoldToStore()?.secondLineName
								}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- contact person -->
				@if (settings.show_contact_person) {
					<div class="flex flex-row">
						<i class="flex flex-col mr-s">
							<vis-ods-icon-component
								name="user"
								height="24px"
								width="24px"
								class="fill-body"
							></vis-ods-icon-component>
						</i>
						<div class="flex flex-col">
							<span class="text-label text-body">
								{{ t('orderSummary.headlines.contactPerson') }}
							</span>
							<div class="flex flex-col text-body-s">
								<div class="flex space-x-2xs">
									@if ($contactPersonsLoading()) {
										<beyond-online-loading-spinner size="2xs"></beyond-online-loading-spinner>
									} @else if (order.shipTo?.contactPerson) {
										<span class="text-input text-headline">
											{{
												order.shipTo?.contactPerson?.firstName +
													' ' +
													order.shipTo?.contactPerson?.lastName
											}}
										</span>
									} @else {
										<span class="text-body">
											{{ t('orderSummary.texts.contactPersonNotSelected') }}
										</span>
									}
								</div>
								@if ($editContactPersonEnabled()) {
									<button
										beyond-online-link
										class="print:hidden text-interaction-link text-left ml-xs"
										(click)="editContactPerson()"
									>
										{{ t('orderSummary.buttons.changeContactPerson') }}
									</button>
								}
							</div>
						</div>
					</div>
				}
				@if (settings.show_tc_of_sales) {
					<hr beyond-online-divider />
					<div class="flex flex-row">
						<i class="flex flex-col mr-s">
							<vis-ods-icon-component
								name="copy"
								height="24px"
								width="24px"
								class="fill-body"
							></vis-ods-icon-component>
						</i>
						<div class="flex flex-col">
							<h4 class="text-label text-body">
								{{ t('orderSummary.headlines.termsAndConditions') }}
							</h4>
							<div class="flex space-x-2xs text-body-s">
								<span>{{ t('orderSummary.texts.termsAndConditions.text') + ' ' }}</span
								><a [href]="settings.tc_of_sales_link" class="text-interaction-link underline">{{
									t('orderSummary.texts.termsAndConditions.link')
								}}</a>
							</div>
						</div>
					</div>
				}
			</div>
		}
	}
</ng-container>
